module.exports = __webpack_public_path__ + "static/pinky-cole-b35e10b947662395752ff8b6bd3d16c4.jpg";